import React, { useState } from "react";
import pClasses from "../Test.module.scss";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { InterfacesTestExample } from "../../../interfaces/InterfacesTest";
import { useTranslation } from "react-i18next";
import ButtonsArea from "../../Buttons/ButtonsArea";
import RoundButton from "../../Buttons/RoundButton";
import Title from "../../Title";
import * as h from "../../../helpers";
import AlertDialogSquare from "../../AlertDialogSquare";

interface TestExamplesInterface {
  examples: InterfacesTestExample | null;
  activeTest: string;
  volume: number;
  onClick: () => void | null;
}

export default function TestExamples({
  examples = null as InterfacesTestExample | null,
  activeTest,
  volume,
  onClick,
}: TestExamplesInterface) {
  const { t } = useTranslation();
  const [isPlayingAudio, setIsPlayingAudio] = useState(false);
  const [hasPlayed, setHasPlayed] = useState(false);
  const [paused, setPause] = useState(false);

  let _content = null as any;
  if (examples && examples.list_examples && examples.list_examples.length > 0) {
    const { title, list_examples } = examples;
    const _btns = [] as any;

    list_examples.forEach((example) => {
      const { audio, text, subtitle } = example;
      _btns.push(
        <div className={pClasses.VertArea} key={h.keyGenerator(audio)}>
          <Title light h3 little>
            {subtitle && t("tests." + subtitle)}
          </Title>
          <RoundButton
            key={audio}
            className={pClasses.BtnPlayHuge}
            disabled={isPlayingAudio}
            faIcon={faPlay}
            huge
            onClick={() =>
              h.playAudioHandler(
                audio,
                activeTest,
                volume,
                isPlayingAudio,
                setIsPlayingAudio,
                setHasPlayed
              )
            }
            title={t("global.play_audio_test")}
          />
          {text && <p>{h.capitalizeFirstLetter(t("tests." + text))}</p>}
        </div>
      );
    });
    const firstAdvice = (
      <div>
        É de extrema importância que, ao iniciar o teste, este seja feito sem
        interrupções <b>e o mais rápido possível.</b>
      </div>
    );
    const secondAdvice = "Não faça pausas entre as questões do teste!";
    const thirdAdvice =
      "Procure um ambiente com poucas distrações e use fones de ouvido.";
    const goAhead = "Deseja começar o teste agora?";
    const advices = (
      <>
        <div>
          {firstAdvice}
          <br />
          <br />
          {secondAdvice}
          <br />
          <br />
          {thirdAdvice}
          <br />
          <br />
          {goAhead}
        </div>
      </>
    );
    _content = (
      <>
        <Title light className={pClasses.testInstruction}>
          {t("tests." + title) ?? ""}
        </Title>
        <ButtonsArea spaceAround bigArea className={pClasses.AreaBtns}>
          {_btns}
        </ButtonsArea>

        {/* <ButtonsArea> */}
        <div className={pClasses.ContentFixedButton}>
          <AlertDialogSquare
            textButton={t("global.start_test")}
            textDialogPrimary={"Atenção!"}
            textDialogSecondary={advices}
            buttonDesabled={isPlayingAudio || !hasPlayed}
            onConfirm={onClick}
          />
        </div>
        {/* </ButtonsArea> */}
      </>
    );
  }
  return <div className={pClasses.BtnsTestExample}>{_content}</div>;
}
